export default __webpack_public_path__ + "static/media/larvacrabs_unknown.c088364d.gif";